import React from "react";

import DefaultLayout from "../../components/layout/defaultLayout";
import PayoutForm from "../../components/forms/payoutForm";

function Payout() {
  return (
    <DefaultLayout>
      <PayoutForm />
    </DefaultLayout>
  );
}

export default Payout;
